import { templates } from 'components/FolderTemplatesDialog/Templates'
import { Select } from 'components/Select/Select'
import { Key } from 'react'
import Styles from './TemplateMenu.module.scss'
import { TemplateMenuProps } from './Types'
import { Item } from '@react-stately/collections'
import { useLabel } from '@react-aria/label'
import { WorkflowTemplate } from 'components/FolderTemplatesDialog/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const TemplateMenu = ({ inheritableTemplate, selectedKey, onSelectionChange }: TemplateMenuProps) => {
  const label = 'Workflow Templates'
  const { isMobile } = useResponsiveDesign()
  const { labelProps, fieldProps } = useLabel({ label })
  const handleSelectionChange = (key: Key) => {
    const template = availableTemplates.find(({ id }) => id === key)
    if (template) {
      onSelectionChange(template)
    }
  }
  const availableTemplates = [...templates, inheritableTemplate].filter(Boolean) as WorkflowTemplate[]

  return (
    <div className={Styles.container}>
      {!isMobile && (
        <label {...labelProps} className={Styles.label}>
          {label}
        </label>
      )}
      <Select selectedKey={selectedKey} onSelectionChange={handleSelectionChange} size="lg" {...fieldProps}>
        {availableTemplates.map((template) => (
          <Item key={template.id} textValue={template.title()}>
            <div className={Styles.option}>
              {template.emoji} {template.title()}
            </div>
          </Item>
        ))}
      </Select>
    </div>
  )
}

export { TemplateMenu }
